import { render } from "./ProductGroupForm.vue?vue&type=template&id=b5ddb49e&ts=true"
import script from "./ProductGroupForm.vue?vue&type=script&lang=ts"
export * from "./ProductGroupForm.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__